export const IMAGES = {
  heroLifestyle:
    "https://images.unsplash.com/photo-1602848137189-ad9301200244?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxhc2lhbiUyMGNvdXBsZSUyMGhpa2luZ3xlbnwwfHx8fDE3ODY2ODYzNDN8MA&ixlib=rb-4.1.0&q=85",
};

export const INGREDIENTS = [
  {
    slug: "uc-ii-collagen",
    num: "01",
    name: "UC-II® Undenatured Type II Collagen",
    patentLogo: "/assets/logo-ucii.png",
    short:
      "Supports immune tolerance to collagen and helps maintain cartilage comfort and flexibility.",
    image:
      "https://images.unsplash.com/photo-1656331797721-b593b8f00297?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwY29sbGFnZW4lMjBtb2xlY3VsZXxlbnwwfHx8fDE3ODY2ODYzNDN8MA&ixlib=rb-4.1.0&q=85",
    overview:
      "UC-II® is a patented form of undenatured (native) Type II collagen derived from chicken sternum cartilage. Unlike hydrolysed collagen, its triple-helix structure remains intact, allowing it to work through a unique immune-mediated pathway at a very low dose.",
    mechanism:
      "UC-II® works through a process called oral tolerance. The intact Type II collagen interacts with Peyer's patches in the gut, training the immune system to recognise the body's own cartilage collagen as safe. This helps reduce the immune-driven attack on joint cartilage, supporting comfort, flexibility and long-term cartilage health.",
    study: {
      summary:
        "UC-II® has a rich, science-backed history — more than 20 years of research and 12 human clinical studies in one small 40 mg daily dose, covering joint discomfort, cartilage thickness, mobility and exercise synergy.",
      population: "Healthy adults & adults with knee OA (ages 18–79)",
      dosage: "40 mg once daily",
      duration: "90 days – 6 months",
    },
    results: [
      "Significantly reduces joint discomfort when climbing, walking up or down stairs, bending and squatting vs placebo",
      "Increases knee cartilage thickness by up to 17% and significantly decreases cartilage breakdown",
      "30% of subjects taking rescue medication (NSAIDs) stopped taking them after 12 weeks of UC-II®",
      "Significantly improved joint function, mobility and flexibility in studies of up to 291 adults",
    ],
    studies: [
      {
        objective: "Joint discomfort during activities of daily living in healthy adults aged 50+",
        subjects: "17 healthy adults, age ≥50 years",
        doseDuration: "40 mg UC-II® or placebo · 120 days",
        outcomes: [
          "Significantly decreased joint discomfort during activities of daily living",
          "Significantly reduced discomfort when climbing, walking up or down stairs, bending, and squatting vs placebo",
        ],
        reference: "Saiyed et al. (2021). J Clin Trials, 11, 14 — randomised, double-blind, placebo-controlled trial.",
      },
      {
        objective: "Cartilage thickness and breakdown in people with osteoarthritis",
        subjects: "30 adults with OA, age 18+ years",
        doseDuration: "40 mg UC-II® · 6 months",
        outcomes: [
          "Significantly increased knee cartilage thickness up to 17%",
          "Significantly decreased cartilage breakdown",
          "30% of subjects on rescue medication (NSAIDs) stopped taking them after 12 weeks",
        ],
        reference: "Yaremenko et al. (2021). PAIN. JOINTS. SPINE. 11(3), 5–12.",
      },
      {
        objective: "Combining muscle-strengthening exercise with UC-II® in people with OA",
        subjects: "60 adults with OA, age 40–75 years",
        doseDuration: "40 mg UC-II® or placebo · 90 days",
        outcomes: [
          "May enhance the benefits of muscle-strengthening exercises",
          "Increased strength and mobility",
        ],
        reference: "Costa AF et al. (2020). Muscles, Ligaments and Tendons Journal, 10(3).",
      },
      {
        objective: "Safety and effectiveness under actual practice conditions",
        subjects: "291 adults with OA, age 28–79 years",
        doseDuration: "40 mg UC-II® · 90 days",
        outcomes: [
          "Significantly improved joint function, mobility and flexibility compared to baseline",
        ],
        reference: "Mehta et al. (2019). International Journal of Research in Orthopaedics, 3(2), 316–320.",
      },
      {
        objective: "Effectiveness in knee osteoarthritis",
        subjects: "100 adults with OA, age 45–65 years",
        doseDuration: "40 mg UC-II® · 120 days",
        outcomes: [
          "Significantly improved joint function, mobility and flexibility compared to baseline",
        ],
        reference: "Azeem et al. (2019). Int J Orthop Traumatol Surg Sci, 6, 172–175.",
      },
    ],
    references: [
      "Saiyed et al. (2021). Efficacy of UC-II® undenatured type II collagen on knee joint function in healthy subjects. J Clin Trials, 11, 14.",
      "Yaremenko et al. (2021). Efficacy, tolerance and influence on cartilage metabolism of UC-II® (Mercana) in knee OA. PAIN. JOINTS. SPINE. 11(3), 5–12.",
      "Costa AF et al. (2020). Associated strengthening exercises to undenatured oral type II collagen (UC-II®). Muscles, Ligaments and Tendons Journal, 10(3).",
      "Mehta et al. (2019). A non-interventional, prospective, multicentric real-life Indian study of un-denatured type 2 collagen. Int J Res Orthop, 3(2), 316–320.",
      "Azeem et al. (2019). The study of undenatured type II collagen in knee osteoarthritis. Int J Orthop Traumatol Surg Sci, 6, 172–175.",
    ],
  },
  {
    slug: "calcium-fructoborate",
    num: "02",
    name: "Calcium Fructoborate",
    patentLogo: "/assets/logo-fruitexb.png",
    short:
      "Supports bone & joint health and helps maintain a healthy inflammatory response.",
    image:
      "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHBvd2RlciUyMHNjaWVuY2V8ZW58MHx8fHwxNzg2Njg2MzU0fDA&ixlib=rb-4.1.0&q=85",
    overview:
      "Calcium fructoborate — known by the patented brand FruiteX-B® — is a nature-identical boron–fructose complex found naturally in fruits and vegetables. It is one of the most bioavailable forms of boron, a trace mineral important for bone and joint metabolism.",
    mechanism:
      "Calcium fructoborate helps modulate key markers of a healthy inflammatory response (including C-reactive protein) and supports the body's use of calcium, magnesium and vitamin D. This dual action supports both bone mineral health and day-to-day joint comfort.",
    study: {
      summary:
        "In a double-blind, placebo-controlled clinical study, calcium fructoborate (FruiteX-B®) at 110 mg twice daily significantly improved knee discomfort within just 2 weeks — with improvements measured as early as day 7.",
      population: "Healthy adults 35–65 with self-reported knee discomfort",
      dosage: "110 mg twice daily (220 mg/day)",
      duration: "14 days",
    },
    results: [
      "29% improvement in WOMAC score and 27% improvement in McGill Pain Index by day 14 vs baseline",
      "Significant improvements already at day 7 (25% WOMAC, 21% McGill)",
      "In a second study, glucosamine + chondroitin was efficacious only when combined with calcium fructoborate",
    ],
    studies: [
      {
        objective: "Short-term efficacy of calcium fructoborate (CFB) on knee discomfort",
        subjects: "60 healthy individuals, 35–65 years, with self-reported knee discomfort",
        doseDuration: "110 mg CFB twice daily · 14 days",
        outcomes: [
          "Day 7 vs baseline: 25% improvement in WOMAC score, 21% improvement in McGill Pain Index",
          "Day 14 vs baseline: 29% improvement in WOMAC score, 27% improvement in McGill Pain Index",
          "Supplementation with 110 mg CFB twice per day was associated with improving knee discomfort during the 2 weeks of intake",
        ],
        reference: "Pietrzkowski Z et al. (2014). Clin Interv Aging, 9, 895–899. doi:10.2147/CIA.S64590.",
      },
      {
        objective: "CFB combined with glucosamine and chondroitin vs glucosamine + chondroitin alone",
        subjects: "90 healthy individuals, 35–65 years, with self-reported knee discomfort",
        doseDuration: "110 mg CFB twice daily (in combination) · 14 days",
        outcomes: [
          "Day 7 vs baseline: 15% improvement in WOMAC score, 14% improvement in McGill Index",
          "Day 14 vs baseline: 24% improvement in WOMAC score, 25% improvement in McGill Index",
          "Short-term treatment with glucosamine and chondroitin was efficacious only if used in combination with CFB",
        ],
        reference: "Reyes-Izquierdo T et al. (2014). J Aging Res Clin Practice, 3(4), 223–228.",
      },
    ],
    references: [
      "Pietrzkowski Z, Phelan MJ, Keller R, Shu C, Argumedo R, Reyes-Izquierdo T (2014). Short-term efficacy of calcium fructoborate on subjects with knee discomfort. Clin Interv Aging, 9, 895–899.",
      "Reyes-Izquierdo T, Phelan MJ, Keller R, Shu C, Argumedo R, Pietrzkowski ZB (2014). Short-term efficacy of a combination of glucosamine and chondroitin sulfate compared to a combination with calcium fructoborate (CFB). J Aging Res Clin Practice, 3(4), 223–228.",
    ],
  },
  {
    slug: "apresflex-boswellia",
    num: "03",
    name: "AprèsFlex® (Boswellia serrata)",
    patentLogo: "/assets/logo-apresflex.png",
    short:
      "Clinically studied to support joint comfort and help improve physical function — with relief reported in as fast as 5–7 days.",
    image:
      "https://images.unsplash.com/photo-1466446230056-1fc585e55d7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwbGFudCUyMGxlYWYlMjBtYWNyb3xlbnwwfHx8fDE3ODY2ODYzNTV8MA&ixlib=rb-4.1.0&q=85",
    overview:
      "AprèsFlex® is a patented, clinically studied Boswellia serrata gum extract, standardised for AKBA — the most active boswellic acid — and engineered for enhanced bioavailability. AprèsFlex® and Aflapin® are the same branded, specialized extract of Boswellia serrata. Each FellesViar capsule delivers the full studied 100 mg dose.",
    mechanism:
      "AprèsFlex® inhibits 5-lipoxygenase (5-LOX), a key enzyme driving inflammatory mediator production in the joint. It is also capable of inhibiting the cartilage-degrading enzyme MMP-3 and helps regulate the inflammatory response by inhibiting ICAM-1 — protecting cartilage while relieving discomfort.",
    study: {
      summary:
        "In randomised, double-blind, placebo-controlled trials, AprèsFlex® (100 mg daily) delivered clinically and statistically significant improvements in pain scores and physical function scores, with meaningful relief reported in as fast as 5–7 days.",
      population: "Adults with knee osteoarthritis (stage 1–3)",
      dosage: "100 mg once daily",
      duration: "30–90 days",
    },
    results: [
      "Fast-acting relief — significant pain score improvements within 5–7 days",
      "Clinically significant gains in physical function and mobility scores",
      "Inhibits cartilage-degrading enzyme MMP-3, supporting long-term cartilage protection",
    ],
    studies: [
      {
        objective: "NC-II and AprèsFlex® (Aflapin) in the management of osteoarthritis — narrative review",
        subjects: "Narrative review of non-clinical and clinical evidence",
        doseDuration: "AprèsFlex® 100 mg daily (as clinically studied)",
        outcomes: [
          "Aflapin (AprèsFlex®) is a novel synergistic Boswellia serrata composition with a higher content of 3-O-acetyl-11-keto-betaboswellic acid (AKBA)",
          "Multiple clinical studies demonstrated the efficacy and safety of NC-II and Aflapin, individually and in combination",
          "The combination can slow disease progression in OA and serve as a safer, effective treatment option compared with long-term NSAID use",
        ],
        reference: "Int J Res Orthop (2024). doi:10.18203/issn.2455-4510.IntJResOrthop20241946 — keywords: undenatured collagen, Boswellia serrata extract, oral tolerance, cartilage regeneration.",
      },
    ],
    references: [
      "Sengupta K et al. A double-blind, randomized, placebo-controlled study of AprèsFlex® (Boswellia serrata extract) in knee osteoarthritis. Int J Med Sci.",
      "Clinical evaluation of AprèsFlex® on pain and physical function scores vs placebo — multi-study program, Lonza Capsules & Health Ingredients.",
      "Narrative review of NC-II and Aflapin in OA management. Int J Res Orthop (2024). doi:10.18203/issn.2455-4510.IntJResOrthop20241946.",
    ],
  },
  {
    slug: "hyaluronic-acid",
    num: "04",
    name: "Hyaluronic Acid",
    short:
      "Helps maintain joint lubrication and supports smooth movement.",
    image:
      "https://images.unsplash.com/photo-1523633589114-88eaf4b4f1a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxibHVlJTIwd2F0ZXIlMjBkcm9wc3xlbnwwfHx8fDE3ODY2ODYzNTV8MA&ixlib=rb-4.1.0&q=85",
    overview:
      "Hyaluronic acid (HA) is a naturally occurring molecule and the primary component of synovial fluid — the body's own joint lubricant. Levels of HA in the joints decline with age and activity-related wear.",
    mechanism:
      "Orally supplemented hyaluronic acid is absorbed and distributed to connective tissues, where it supports the viscosity and cushioning properties of synovial fluid. Better lubrication means smoother, more comfortable movement and reduced friction between cartilage surfaces.",
    study: {
      summary:
        "Randomised controlled trials of oral hyaluronic acid show improvements in joint comfort, stiffness and daily mobility scores, particularly in adults with age-related knee concerns.",
      population: "Adults aged 35–70 experiencing joint stiffness",
      dosage: "80–200 mg once daily",
      duration: "60–365 days",
    },
    results: [
      "Improved joint lubrication and smoother range of motion",
      "Reduced morning stiffness scores vs placebo",
      "Supports skin hydration as a complementary benefit",
    ],
    references: [
      "Tashiro T et al. Oral administration of hyaluronic acid in knee discomfort: RCT. Sci Rep, 2012.",
      "Oe M et al. Oral hyaluronan relieves joint discomfort: a review. Nutr J, 2016.",
    ],
  },
];

export const FAQS = [
  {
    q: "Who can take FellesViar?",
    a: "FellesViar is formulated for adults who want to support joint comfort, cartilage health and everyday mobility — especially those experiencing age-related stiffness or active individuals placing regular load on their joints. If you have an impaired liver or kidney, it is not advisable to take FellesViar. If you are pregnant, nursing or on medication, consult your healthcare professional first.",
  },
  {
    q: "Are there any precautions I should know?",
    a: "Yes. If you have an impaired liver or kidney, it is not advisable to take FellesViar. Consume after a meal, as Boswellia can be sensitive for those with gastric discomfort.",
  },
  {
    q: "How long does it take to see results?",
    a: "AprèsFlex®, the Boswellia serrata extract in FellesViar, has shown relief in as fast as 5–7 days in clinical studies. For comprehensive cartilage and mobility support, consistent daily use for 4–12 weeks is recommended, in line with the clinical study durations.",
  },
  {
    q: "Is it safe for long-term use?",
    a: "Yes. The four ingredients in FellesViar have been clinically studied for periods of up to 6–12 months with excellent safety and tolerability profiles. It is designed as a daily, long-term joint health supplement.",
  },
  {
    q: "Are there any side effects?",
    a: "FellesViar is generally well tolerated. In clinical studies, reported side effects were rare and mild, comparable to placebo. If you have a known allergy to any ingredient (including chicken-derived collagen), consult your doctor before use.",
  },
  {
    q: "How should I take FellesViar?",
    a: "Adults: take one capsule after a meal, once daily. Each box contains 30 vegetable capsules — a full month's supply. Consistency matters more than timing — take it at the same time each day for best results.",
  },
  {
    q: "Is FellesViar Halal certified?",
    a: "Yes, FellesViar is Halal certified and manufactured in GMP-compliant facilities, making it suitable for Muslim consumers in Malaysia and the region.",
  },
  {
    q: "Can I take FellesViar with other supplements?",
    a: "FellesViar can generally be taken alongside common supplements such as calcium, vitamin D or fish oil. If you are taking prescription medication, check with your pharmacist or doctor first.",
  },
  {
    q: "Where is FellesViar made?",
    a: "FellesViar is developed based on scientific research and manufactured in GMP-certified facilities under strict quality standards, and distributed by Aspen Sarl Sdn. Bhd. in Malaysia.",
  },
];

export const MARQUEE_ITEMS = [
  "Mobility that lasts",
  "4 Clinically Studied Ingredients",
  "Backed by Scientific Research",
  "Halal Certified",
  "Suitable for Long-term Use",
];

export const CONTACT = {
  company: "Aspen Sarl Sdn Bhd.",
  phones: ["03-5637 8232", "03-5633 0319"],
  email: "cs.support@aspensarl.com",
  address: "9, Jalan PJS 11/14, Bandar Sunway, 46150 Subang Jaya, Selangor, Malaysia",
};
